import * as Yup from 'yup';

export const OtpVerifySchema = Yup.object().shape({
  Otp: Yup.string().required('OTP is required')
});
